module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00023.4df9aa22.jpg";